import React from "react";
import { FormFeedback } from "reactstrap";
import { ErrorOutlineOutlined } from "@mui/icons-material";
import { AnimatePresence, motion } from "motion/react";
import { slideInUp } from "../../utils/animations/commonAnimations";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

export interface AnimatedErrorMessageProps {
  show: boolean;
  message?: string;
  variant?: "form" | "standalone";
  className?: string;
}

const AnimatedErrorMessage: React.FC<AnimatedErrorMessageProps> = ({
  show,
  message,
  variant = "standalone",
  className = "",
}) => {
  if (!show || !message) {
    return null;
  }

  const content = (
    <>
      <ErrorOutlineOutlined 
        className={s.errorIcon} 
        style={{ fontSize: '19px', marginRight: '6px', marginTop: '-2px' }} 
      />
      {message}
    </>
  );

  return (
    <AnimatePresence>
      <motion.div {...slideInUp}>
        {variant === "form" ? (
          <FormFeedback className={`d-block ${s.errorMessage} ${className}`}>
            {content}
          </FormFeedback>
        ) : (
          <div className={`d-block ${s.errorMessage} ${className}`}>
            {content}
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default withStyles(s)(AnimatedErrorMessage);